import { Link } from "react-router-dom";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
	Button,
} from "@/components/primitives";
import { Shield, UserPlus } from "lucide-react";

export function AdminPanel() {
	return (
		<div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 p-4">
			<div className="max-w-4xl mx-auto py-8">
				<div className="mb-8">
					<div className="flex items-center gap-3 mb-2">
						<div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
							<Shield className="w-6 h-6 text-white" />
						</div>
						<div>
							<h1 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
								Admin Panel
							</h1>
							<p className="text-gray-600 dark:text-gray-400 mt-1">
								Manage users and system settings
							</p>
						</div>
					</div>
				</div>

				<div className="grid gap-6 md:grid-cols-2">
					<Card className="shadow-lg border-0 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm hover:shadow-xl transition-shadow">
						<CardHeader>
							<div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center mb-2">
								<UserPlus className="w-5 h-5 text-white" />
							</div>
							<CardTitle>Invite Users</CardTitle>
							<CardDescription>
								Send invitations to new mentors or mentees
							</CardDescription>
						</CardHeader>
						<CardContent>
							<Link to="/admin/invite">
								<Button className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white">
									<UserPlus className="w-4 h-4 mr-2" />
									Invite User
								</Button>
							</Link>
						</CardContent>
					</Card>

					{/* Placeholder for future admin features */}
					<Card className="shadow-lg border-0 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm opacity-60">
						<CardHeader>
							<div className="w-10 h-10 bg-gray-300 dark:bg-gray-700 rounded-lg flex items-center justify-center mb-2">
								<Shield className="w-5 h-5 text-gray-500" />
							</div>
							<CardTitle className="text-gray-500">More Features</CardTitle>
							<CardDescription className="text-gray-400">
								Additional admin tools coming soon
							</CardDescription>
						</CardHeader>
						<CardContent>
							<Button disabled className="w-full" variant="outline">
								Coming Soon
							</Button>
						</CardContent>
					</Card>
				</div>
			</div>
		</div>
	);
}
